import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import StorageManager from "@/features/storage";

interface ProtectYourIdentityProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onContinue: () => void;
}

export const ProtectYourIdentity = ({
  isOpen,
  onOpenChange,
  onContinue,
}: ProtectYourIdentityProps) => {
  const { t } = useTranslation();

  const [showAgain, setShowAgain] = useState(false);
  function showAgainCheckboxPressed(value: boolean) {
    setShowAgain(value);
    StorageManager.setProtectYourIdentityMessage(value);
  }

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>
            {t("receiptClaim_protectYourIdentity_title")}
          </DialogTitle>
        </DialogHeader>
        <DialogDescription>
          {t("receiptClaim_protectYourIdentity_message")}
        </DialogDescription>

        <div className="flex items-center space-x-2">
          <Checkbox
            checked={showAgain}
            onCheckedChange={showAgainCheckboxPressed}
            id="protect-id-checkbox"
          />

          <Label htmlFor="protect-id-checkbox">
            <span>
              {t("receiptClaim_protectYourIdentity_dontShowAgainButtonTitle")}
            </span>
          </Label>
        </div>

        <DialogFooter>
          <Button type="button" onClick={onContinue}>
            {t("ok")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
